module.exports = __webpack_public_path__ + "img/arrow-up.60706731.svg";